import type { AGGItemProviderProps } from '../../common/types/item-provider.tsx';

export const BoardsProvider = (props: AGGItemProviderProps) => {
	const { children } = props;

	// The tab content fetches its own data using Relay, and lint rules/Relay conventions dictate that we can't put the query here.
	// This provider is just here so the rendering can be handled consistently with the other tabs.
	return children();
};
